module.exports = __webpack_public_path__ + "assets/img/icon5.6405db75.svg";